interface ErrorResponse {
    code: number;
    message: string;
}

export interface JackpotTrackingState {
    jackpotTrackingeData: any;
    loading: boolean;
    jackpotTrackingeError: ErrorResponse | null;
}


export enum JackpotTrackingActionTypes {
    FETCH_JACKPOT_TRACKING_DATA = "FETCH_JACKPOT_TRACKING_DATA",
    FETCH_JACKPOT_TRACKING_DATA_SUCCESS = "FETCH_JACKPOT_TRACKING_DATA_SUCCESS",
    FETCH_JACKPOT_TRACKING_DATA_ERROR = "FETCH_jackpot_TRACKING_DATA_ERROR",
}

export type JackpotTrackingAction =
    | { type: JackpotTrackingActionTypes.FETCH_JACKPOT_TRACKING_DATA }
    | { type: JackpotTrackingActionTypes.FETCH_JACKPOT_TRACKING_DATA_SUCCESS; payload: any[] }
    | { type: JackpotTrackingActionTypes.FETCH_JACKPOT_TRACKING_DATA_ERROR; payload: any };